import React from 'react';
import { Button, IconButton, Popover, Typography } from '@mui/material'; // Added IconButton, Popover, Typography
import InfoIcon from '@mui/icons-material/Info'; // Example Icon
import styles from './MaskedContactInfo.module.css';

interface MaskedContactInfoProps {
  tokensRemaining: number;
  onViewContactInfoClick: () => void;
  onPurchaseTokensClick: () => void; // For when user needs to buy tokens
}

const MaskedContactInfo: React.FC<MaskedContactInfoProps> = ({
  tokensRemaining,
  onViewContactInfoClick,
  onPurchaseTokensClick,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const openPopover = Boolean(anchorEl);
  const popoverId = openPopover ? 'masked-info-popover' : undefined;

  return (
    <>
      <div className={styles.banner}>
        <div className={styles.contentWrapper}>
          <IconButton onClick={handleIconClick} size="small" aria-describedby={popoverId} className={styles.infoIconButton}>
            <InfoIcon className={styles.icon} />
          </IconButton>
          <div className={styles.textContainer}>
            <p className={styles.mainText}>Contact information is hidden.</p>
            <p className={styles.subText}>
              Spend 1 token to view full details.<br />Tokens remaining: {tokensRemaining}
            </p>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={tokensRemaining > 0 ? onViewContactInfoClick : onPurchaseTokensClick} 
            className={styles.viewButton}
          >
            {tokensRemaining > 0 ? 'View Contact Info' : 'Purchase Tokens to View Contact Info'}
          </Button>
        </div>
      </div>
      <Popover
        id={popoverId}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          className: styles.infoPopoverPaper // New style for this popover
        }}
      >
        <Typography sx={{ p: 2, maxWidth: 280 }}>
          To protect candidate privacy and ensure fair value exchange, direct contact information is revealed after a token is used.
        </Typography>
      </Popover>
    </>
  );
};

export default MaskedContactInfo; 